import * as Yup from 'yup';

export const historyFormSchema = Yup.object().shape({
  equipmentServiceID: Yup.string().required('Equipment service is required'),
});
